import { FC, useCallback, useState } from "react";
import { Link, Typo, User } from "#/atoms";
import { StyledSubmenu, StyledUserMenu } from "./UserMenu.styled";

import { PRIMARY_BLUE } from "@/theme";
import { UserMenuProps } from "./UserMenu.interface";

const UserMenu: FC<UserMenuProps> = ({ onEditProfile, onLogout, ...userProps}) => {
  const [showSubmenu, setShowSubmenu] = useState(false);

  const handleMouseOver = useCallback((ev: React.MouseEvent<HTMLDivElement>) => {
    ev.stopPropagation();
    setShowSubmenu(true)
  }, []);
  const handleMouseLeave = useCallback((ev: React.MouseEvent<HTMLDivElement>) => {
    ev.stopPropagation();
    setShowSubmenu(false)
  }, []);

  return (
    <StyledUserMenu onMouseLeave={handleMouseLeave}>
      <User {...userProps} onMouseOver={handleMouseOver} />
      {showSubmenu && (
        <StyledSubmenu>
          <Link fontColor={PRIMARY_BLUE.DARK} onClick={onEditProfile}>Edit Profile</Link>
          <br/>
          <br/>
          <Link fontColor={PRIMARY_BLUE.DARK} onClick={onLogout}>Logout</Link>
          <br/>
          <br/>
          <Typo fontColor={PRIMARY_BLUE.DARK}>V04011</Typo>
        </StyledSubmenu>
      )}
    </StyledUserMenu>
  );
};

export default UserMenu;
